module.exports = __webpack_public_path__ + "img/multiple-actions-shield.a8d26529.svg";